import type { ChildDom } from "vanjs-core";
import { locale } from "../locale";
import { div, input, label } from "./van-tags";

interface NameFieldParams {
	getName: () => string;
	setName: (name: string) => void;
}

export function nameField(args: NameFieldParams): ChildDom {
	return div(
		{ class: "field" },
		label(
			{ class: "label" },
			locale.string({
				enGB: "Name",
				deDE: "Name",
				frFR: "Nom",
				svSE: "Namn",
			}),
		),
		div(
			{ class: "control" },
			input({
				class: "input",
				oninput: (e: Event) => {
					if (!(e.target instanceof HTMLInputElement)) return;
					args.setName(e.target.value);
				},
				type: "text",
				value: () => args.getName(),
			}),
		),
	);
}
